import React from 'react'
import { Trans } from 'react-i18next'

/** Charging sessions export button step component */
export const ChargingSessionsExportStep: React.FC = () => {
  return <Trans i18nKey="emobility.tour.charging-session-export-button" components={{ strong: <strong /> }} />
}
